import { Compass } from 'lucide-react'
import { useNavigate } from 'react-router'

import { EmptyState } from '@/components/ui'

export function NotFoundPage() {
  const navigate = useNavigate()

  return (
    <div className="mx-auto w-full max-w-2xl px-4">
      <EmptyState
        icon={Compass}
        title="This page does not exist"
        description="The link may be out of date, or the page may have moved."
        action={{ label: 'Go to your library', onClick: () => void navigate('/') }}
      />
    </div>
  )
}
